import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios from 'axios';

export interface ICorporateApi {
  getSelectedOffer(offerNumber: string): Promise<APIResponse<any>>;
  getDocumentContent(offerNumber: string, documentUuid: string): Promise<APIResponse<any>>;
  getInsuredGoods(): Promise<APIResponse<any>>;
  retrieveOffer(prospection: any): Promise<APIResponse<any>>;
  sendEfirestMail(email: string, code: string): Promise<APIResponse<any>>;
}

export class CorporateApi implements ICorporateApi {
  async getSelectedOffer(offerNumber: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get('journey/offers/' + offerNumber, {
        headers: {
          'Accept-Language': 'fr-FR'
        }
      })
    );
  }

  async getDocumentContent(offerNumber: string, documentUuid: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios({
        url: 'journey/offers/' + offerNumber + '/documents/' + documentUuid,
        method: 'GET',
        responseType: 'blob' // important
      })
    );
  }

  async getInsuredGoods(): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get('api/insuredgoods', {
        headers: {
          'Accept-Language': 'fr-FR'
        }
      })
    );
  }

  async retrieveOffer(prospection: any): Promise<APIResponse<any>> {
    return returnAxios(
      axios.post('journey/retrieveOffer', prospection, {
        headers: {
          'Accept-Language': 'fr-FR'
        }
      })
    );
  }
  async sendEfirestMail(email: string, code: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.post(
        'email/sendEfirestEmail',
        { customerEmail: email, offerCode: code },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
    );
  }
}
